import React, { FC, useId } from 'react';
import { useField } from 'formik';
import { IFormFieldProps } from '@components/Form/types';
import { Textarea } from '@components/Textarea';
import { Field } from '../Field';

export const TextareaField: FC<IFormFieldProps> = (props) => {
  const {
    id = '',
    showLabel = true,
    label = '',
    showHint = true,
    hint = '',
    showRequired = false,
    required = true,
    fieldControls,
  } = props;

  const uniqId = useId();

  const fieldId = id || uniqId;

  const [field, meta] = useField(props);

  return (
    <Field
      id={fieldId}
      showLabel={showLabel}
      label={label}
      showError={meta.touched}
      error={meta.error}
      showHint={showHint}
      hint={hint}
      showRequired={showRequired}
      isRequired={required}
      fieldControls={fieldControls}
    >
      <div className="field-control">
        <Textarea {...field} {...props} hasError={meta.touched && !!meta.error} />
      </div>
    </Field>
  );
};
